/**
 * BroadcastChannel API für Cross-Tab-Synchronisation
 */
const LEADS_CHANNEL = 'aiqcon_leads_sync';
const OFFERS_CHANNEL = 'aiqcon_offers_sync';

let leadsChannel = null;
let offersChannel = null;

const isBroadcastSupported = () => typeof BroadcastChannel === 'function';

const initChannels = () => {
  if (!isBroadcastSupported()) return false;
  try {
    if (!leadsChannel) leadsChannel = new BroadcastChannel(LEADS_CHANNEL);
    if (!offersChannel) offersChannel = new BroadcastChannel(OFFERS_CHANNEL);
    return true;
  } catch {
    return false;
  }
};

export const broadcastLeads = (leads) => {
  try {
    if (!leadsChannel && !initChannels()) return;
    if (!leadsChannel) return;
    leadsChannel.postMessage({ type: 'leads_update', leads, timestamp: Date.now() });
  } catch {}
};

export const broadcastOffers = (offers) => {
  try {
    if (!offersChannel && !initChannels()) return;
    if (!offersChannel) return;
    offersChannel.postMessage({ type: 'offers_update', offers, timestamp: Date.now() });
  } catch {}
};

export const subscribeToLeadUpdates = (callback) => {
  try {
    if (!leadsChannel && !initChannels()) return () => {};
    if (!leadsChannel) return () => {};

    const handler = (event) => {
      if (event.data?.type === 'leads_update') callback(event.data.leads);
    };
    leadsChannel.addEventListener('message', handler);
    return () => {
      try { leadsChannel.removeEventListener('message', handler); } catch {}
    };
  } catch {
    return () => {};
  }
};

export const subscribeToOfferUpdates = (callback) => {
  try {
    if (!offersChannel && !initChannels()) return () => {};
    if (!offersChannel) return () => {};

    const handler = (event) => {
      if (event.data?.type === 'offers_update') callback(event.data.offers);
    };
    offersChannel.addEventListener('message', handler);
    return () => {
      try { offersChannel.removeEventListener('message', handler); } catch {}
    };
  } catch {
    return () => {};
  }
};

try { initChannels(); } catch {}
